/** Client UI locale — always English (never browser / OS locale). */
export const CLIENT_DISPLAY_LOCALE = "en-GB";

/** Display date from DB `expiring_date` (YYYY-MM-DD). */
export function formatExpiringDate(iso) {
  const raw = String(iso || "").trim().slice(0, 10);
  if (!raw) return "—";
  const d = new Date(`${raw}T12:00:00`);
  if (Number.isNaN(d.getTime())) return raw;
  return d.toLocaleDateString(CLIENT_DISPLAY_LOCALE, {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
}
